import { tr } from '@btsis/i18n';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export const DEFAULT_LOCALE = 'tr';

export function initI18n() {
  if (i18n.isInitialized) return i18n;
  void i18n.use(initReactI18next).init({
    resources: { tr: { translation: tr } },
    lng: DEFAULT_LOCALE,
    fallbackLng: DEFAULT_LOCALE,
    interpolation: { escapeValue: false },
    returnNull: false,
  });
  return i18n;
}

/**
 * Whether a key resolves to a string, so an error can prefer its most specific
 * translation and fall back to a broader one rather than rendering a raw key.
 */
export function hasTranslation(key: string): boolean {
  return i18n.exists(key) && typeof i18n.t(key, { returnObjects: true }) === 'string';
}

export type { TranslationTree } from '@btsis/i18n';
export { tr };
